import { render, staticRenderFns } from "./transform-staff-modal.vue?vue&type=template&id=746381f0&scoped=true"
import script from "./transform-staff-modal.vue?vue&type=script&lang=js"
export * from "./transform-staff-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746381f0",
  null
  
)

export default component.exports